(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alaska-fishermen-block"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($){
    $('.fisher-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      variableWidth: true,
      autoplaySpeed: 3000,
      infinite: true,
      autoplay: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                    }
                }
            ]
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alaska-tab"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function($) {
  if($(window).width() <= 750 ){
    $('#tabs-section').responsiveTabs({
      startCollapsed: 'accordion',
      startCollapsed: false
    });
  }else {
    $('#tabs-section').responsiveTabs({
      startCollapsed: 'accordion'
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alaska-testimonial-metafields"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function($) {
    $('.multiple-items').slick({
      dots: false,
      infinite: false,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      appendArrows: ".slider-controls-1"
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alaska-testimonial"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($){
    $('.multiple-items').slick({
        dots: false,
        autoplay: true,
        infinite: true,
        speed: 9000,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        appendArrows: ".slider-controls-1"
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alaska-testimonials-home"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function($) {
    $('.text-image-carousel').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 9000,
      adaptiveHeight: false,
      fade: true,
      accessibilty: false,
      focusOnSelect: true

// appendArrows: ".slide-next",

    });
    $(".text-image-carousel .slide-prev").click(function(e) { // Added a '.'
      $(".text-image-carousel.slick-slider").slick("slickPrev"); // Switched to '.slick-slider'
    });
    $(".text-image-carousel .slide-next").click(function(e) { // Added a '.'
      $(".text-image-carousel.slick-slider").slick("slickNext"); // Switched to '.slick-slider'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog-carousel"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($){
  $('.blog__posts-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: true,
      dots: true,
      variableWidth: true,
      autoplaySpeed: 3000,
       infinite: false,
        autoplay: false,
        customPaging : function(slider, i) {
            var thumb = jQuery(slider.$slides[i]).data();
            // return '<a>'+(i+1)+'</a>'; // <-- old
            return '<a>'+('0'+(i+1)).slice(-2)+'</a>'; // <-- new
        },
            responsive: [
                {
                    breakpoint: 920,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
						slidesToScroll: 1,
                    }
                }
            ]
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
